import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { gamesAPI } from '../services/api';
import GameRoom from './GameRoom';
import RaubGameRoom from './RaubGameRoom';
import SedmicaGameRoom from './SedmicaGameRoom';

interface Game {
  gameVariant: 'lower_green' | 'raub' | 'sedmica';
}

const GameRoomRouter: React.FC = () => {
  const { gameId } = useParams<{ gameId: string }>();
  const { user } = useAuth();
  const [game, setGame] = useState<Game | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGame = async () => {
      if (!gameId) return;
      
      try {
        const response = await gamesAPI.getById(gameId);
        setGame(response.data);
      } catch (error) {
        console.error('Error loading game:', error);
      } finally {
        setLoading(false);
      }
    };

    loadGame();
  }, [gameId]);

  if (loading) {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white'
      }}>
        <div>Loading game...</div>
      </div>
    );
  }

  if (!game) {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white'
      }}>
        <div>Game not found</div>
      </div>
    );
  }

  switch (game.gameVariant) {
    case 'raub':
      return <RaubGameRoom />;
    case 'sedmica':
      return <SedmicaGameRoom />;
    case 'lower_green':
    default:
      return <GameRoom />;
  }
};

export default GameRoomRouter; 